export const periodMetricsCardsProps = {
    period: {
        id: "period",
        num: "1",
        title: "Period Settings",
        description: "Настройка периода",
        list: ["Выбор своего периода", "Выбор предустановленного периода"],
        cardLink: "/settings-period",
    },
    metrics: {
        id: "metrics",
        num: "2",
        title: "Metrics Settings",
        description: "Настройка метрик",
        list: ["Выбор нужных показателей", "Отображение их на графике"],
        href: "/settings-metrics",
        name: "Metrics Settings",
        href2: "/settings-metrics",
        name2: "Как настраивать метрики",
        href3: "/metrics",
        name3: "Описание метрик",
    },
};
